import { useSnapshot } from "valtio";
import context from "lib/stores/context";
import classNames from "classnames";
import styles from "./DetailsPaneTable.module.scss";
import detailsPaneTableRowStyles from "./DetailsPaneTableRow.module.scss";
import countryISOFromName from "lib/helpers/countryISOFromName";
import regionISOFromName from "lib/helpers/regionISOFromName";
import mapData from "lib/stores/mapData";
import { ReactComponent as DocumentIcon } from "components/icons/document.svg";

const DetailsPaneTableRow = ({ data }) => {
  const { activeCountry, activeView, activeTabRegions, activeTabWorldwide } =
    useSnapshot(context);
  const { year } = useSnapshot(mapData);

  const onClick = (tab: number): void => {
    if (activeView === "worldwide") {
      if (activeTabWorldwide === 1) {
        context.activeRegion = regionISOFromName(data.name);
        context.activeView = "region";
        context.activeTabRegions = tab;
      }
      if (activeTabWorldwide === 0) {
        context.activeCountry = countryISOFromName(data.name);
        context.activeRegion = data.region_id;
        context.activeView = "country";
        context.activeTabCountries = tab;
        // context.isCollapsed = true;
        if (data.g20) {
          mapData.productsCountry = data.iso;
          mapData.showProducts = true;
          mapData.showProductsMobile = true;
        }
      }
    }
    if (activeView === "region") {
      if (activeTabRegions === 1) {
        context.activeRegion = data.region_id;
        context.activeView = "region";
      }
      if (activeTabRegions === 0) {
        context.activeCountry = countryISOFromName(data.name);
        context.activeRegion = data.region_id;
        context.activeView = "country";
        context.activeTabCountries = tab;
      }
    }
  };

  const renderCount = () => {
    if (activeView === "worldwide" && activeTabWorldwide === 1) {
      if (`${data.documents.length}`.split("").length > 1) {
        return (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClick(1);
            }}
            style={{ transform: "translate(2.25px, 7px)" }}
            className="font-bold  text-black text-xs flex items-center justify-center relative z-1"
          >
            <span className="origin-center scale-[0.95]">
              {data.documents.length}
            </span>
          </button>
        );
      }
      return (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick(1);
          }}
          style={{ transform: "translate(5.5px, 7px)" }}
          className="font-bold text-black text-xs flex items-center justify-center relative z-1"
        >
          <span>{data.documents.length}</span>
        </button>
      );
    }
    if (`${data.documents_count}`.split("").length > 1) {
      return (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick(1);
          }}
          style={{
            transform: "translate(2.25px, 7px)",
          }}
          className="font-bold  text-black text-xs flex items-center justify-center relative z-1"
        >
          <span className="origin-center scale-[0.95]">
            {data.documents_count}
          </span>
        </button>
      );
    }
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClick(1);
        }}
        style={{ transform: "translate(5.5px, 7px)" }}
        className="font-bold text-black text-xs flex items-center justify-center relative z-1"
      >
        <span>{data.documents_count ?? data.documents.length}</span>
      </button>
    );
  };

  const renderPrevalence = () => {
    let value;
    if (data[year]?.prevalence.toFixed(1) === "0.0") {
      value = "-";
    } else {
      value = data[year]?.prevalence.toFixed(1);
    }
    return (
      <td
        className={classNames(
          detailsPaneTableRowStyles["details-pane-general-cell"],
          "md:col-span-1 col-span-2",
        )}
      >
        <span className="text-black flex items-center justify-center pr-5">
          {value}
        </span>
      </td>
    );
  };

  return (
    <tr
      onClick={() => onClick(0)}
      onKeyDown={() => onClick(0)}
      style={{ borderColor: "rgb(229, 231, 235)" }}
      className="cursor-pointer w-full grid text-sm md:grid-cols-6 grid-cols-12 pl-[1.1rem] py-3 border-b-[1px] hover:bg-gray-50 transition-all duration-300 ease-out"
    >
      <td className="md:col-span-2 col-span-4 w-full">
        <span className={detailsPaneTableRowStyles["details-pane-name-cell"]}>
          {data.name}
        </span>
      </td>
      <td className="relative md:left-7 left-auto right-0 md:col-span-1 col-span-2">
        <div className={classNames(styles.outerWrapper, "group")}>
          <div className={styles.container}>
            <div className="group-hover:text-[#FFCC2B] text-transparent absolute top-[5%] translate-y-[1px] md:-left-[2%] h-6 w-6">
              <DocumentIcon />
            </div>
            {renderCount()}
          </div>
        </div>
      </td>
      {renderPrevalence()}
      <td
        className={classNames(
          detailsPaneTableRowStyles["details-pane-general-cell"],
          "md:col-span-1 col-span-2",
        )}
      >
        <span className="text-black flex items-center justify-center pr-2">
          {Math.round(data[year]?.vulnerability) || "-"}
        </span>
      </td>
      <td
        className={classNames(
          detailsPaneTableRowStyles["details-pane-general-cell"],
          "md:col-span-1 col-span-2",
        )}
      >
        <span className="text-black flex items-center justify-center text-right translate-x-2">
          {Math.round(data[year]?.govresponse) || "-"}
        </span>
      </td>
    </tr>
  );
};

export default DetailsPaneTableRow;
